export class TranslationsDto {
}
